"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLoader = void 0;
const react_1 = __importDefault(require("react"));
const f_loader_gif_1 = __importDefault(require("../assets/images/f-loader.gif"));
const FLoader = ({ loading = false, loaderImage = f_loader_gif_1.default, type = "page", width = 50, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null, loading && (react_1.default.createElement("div", { className: `f-loader f-${type}` },
        react_1.default.createElement("img", { src: loaderImage ? f_loader_gif_1.default : loaderImage, alt: "loading", style: { width: `${width}px` } })))));
};
exports.FLoader = FLoader;
//# sourceMappingURL=Floader.js.map